import dayjs from 'dayjs';

export const formatDate = (value: string | number | Date): string => {
  const date = dayjs(value);

  if (!date.isValid()) {
    return '';
  }

  if (date.isSame(dayjs(), 'day')) {
    return `сегодня в ${date.format('HH:mm')}`;
  }

  if (date.isSame(dayjs().subtract(1, 'day'), 'day')) {
    return `вчера в ${date.format('HH:mm')}`;
  }

  return date.format('DD.MM.YYYY');
};
